export default {
  cognito: {
    USER_POOL_ID: 'us-east-1_RI7qfwVJO',
    APP_CLIENT_ID: '7nj8l8a2uo89bonnbp230t2kvc',
    REGION: 'us-east-1',
    IDENTITY_POOL_ID: 'us-east-1:443444f8-33b8-496f-ac2a-db4bb9f0c1c3'
  },
  api: {
    REGION: 'us-east-1',
    URL: '/api'
  }
}



// WEBPACK FOOTER //
// ./src/api/config.js